<template>
  <el-row>
    <el-row class="status-message">
      <el-row type="flex" justify="center"><p>手机号{{phone}}</p></el-row>
      <el-row type="flex" justify="center"><p>您的密码已重置，请重新登录</p></el-row>
    </el-row>
    <el-row type="flex" justify="center">
      <el-button type="primary" @click="onSubmit">重新登录</el-button>
    </el-row>
  </el-row>
</template>

<script>
export default {
  data () {
    return {
      currentSteps: 3,
      phone: '',
    }
  },
  created () {
    let num = JSON.parse(sessionStorage.getItem('mobileVerification')).phone
    let reg = /^(\d{3})\d{4}(\d{4})$/
    this.phone = num.replace(reg, '$1****$2')
  },
  props: ['steps'],
  methods: {
    async onSubmit () {
      this.$router.replace('/')
    },
  },
}
</script>

<style scoped lang="scss">
@import "src/scss/var/colors";

.status-message {
  font-size: 0.8em;
  margin: 40px 0 40px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/password/step3.vue